__turbopack_context__.v({
  "blurSlideIn": "IntroAnimation-module__4W85cW__blurSlideIn",
  "dynamicTextWrapper": "IntroAnimation-module__4W85cW__dynamicTextWrapper",
  "dynamicWord": "IntroAnimation-module__4W85cW__dynamicWord",
  "fadeOutOverlay": "IntroAnimation-module__4W85cW__fadeOutOverlay",
  "overlay": "IntroAnimation-module__4W85cW__overlay",
  "staticText": "IntroAnimation-module__4W85cW__staticText",
  "textContainer": "IntroAnimation-module__4W85cW__textContainer",
});
